import * as React from "react";
const SvgConstraintsVertical = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 2H15V4H13L13 20H15V22H9V20H11L11 4H9V2Z", fill: "currentColor" }));
export default SvgConstraintsVertical;
